<script>

    import _                        from 'lodash'
    import { getContext, onMount }  from 'svelte'
    import { fade }                 from 'svelte/transition'
    import * as api                 from '../../shared/api.js'
    import Issues                   from '../../shared/Issues.svelte'

    export let domain
    export let inventory
    export let place
    export let issues = []
  
    const ctx = getContext('inventory')

    let processors = []
    let loading    = false
    let working    = {}
    let errors     = {}

    $: selected = place.processors || []

    onMount(load)

    function load() {
        loading = true
        api
          .get(`/processors/domain/${domain.id}`)
          .then(api.toJsonIf200)
          .then(json => {
              loading    = false
              processors = json
          }).catch(err => {
              console.log(err)
              loading  = false
          })
    }

    function update(processor) {
      return () => {
        const add = !selected.find(n => n === processor.id)
        const url = `/inventory/domain/${domain.id}/${add ? 'add' : 'remove'}/processor` 

        working[processor.id] = true
        errors[processor.id]  = false
        api
          .post(url, { place: place.id, processor: processor.id })
          .then(api.delay(250))
          .then(api.toJsonIf200)
          .then(json => {
            working[processor.id] = false
            errors[processor.id] = false
            ctx.set(json)
          })
          .catch(err => {
            console.log(err)
            working[processor.id] = false
            errors[processor.id]  = add ? "erro adicionando" : "erro removendo"
            setTimeout(() => { errors[processor.id] = false }, 2000)
          })
      }
    }    

    function removeIf(processor) {
        return () => {
            if(selected && selected === processor.id) {
                update(processor)()
            }
        }
    }

    $: anyWorking = Object.keys(working).find(key => working[key])
    
</script>

<h3 class="ui header">Operadores</h3>

{#if issues.length > 0}
  <div class="ui basic segment">
      <Issues {issues}>
          Problemas:
      </Issues>
  </div>
{/if}

{#if loading || processors.length > 0}
  <div class="ui segments" class:loading>
    {#each processors as processor (processor.id)}
      <div class="ui left aligned segment item">
          <div  class="ui toggle big checkbox" 
                class:disabled={anyWorking}>
              <input type="checkbox" 
                     value={processor.id} 
                     bind:group={selected}
                     on:click={removeIf(processor)} 
                     on:change={update(processor)}>
              <label>
                <h4 class="ui header">{processor.name}</h4>
                <div class="description">{processor.description || ''}</div>
                <!-- {processor.id} => {JSON.stringify(selected)} -->
              </label>
          </div>
          {#if working[processor.id]}
            <div transition:fade class="bottom-right">
              <i class="notched circle loading icon"></i>
            </div>
          {/if}
          {#if errors[processor.id]}
            <div transition:fade class="bottom-right">
              <div class="ui small red label">{errors[processor.id]}</div>
            </div>
          {/if}
      </div>
    {/each}
  </div>
{/if}

<style>
  h3.ui.header {
      margin-top: 3em;
  }
  .description {
    color: #ccc;
    font-size: 1em;
  }

  .item {
    position: relative;

  }

  .bottom-right {
    position: absolute;
    right: 10px;
    bottom: 10px;
  }

  .ui.checkbox.disabled {
    pointer-events: none;
  }

</style>